
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.739 15.739a.914.914 0 000-1.272L9.28 8 15.74 1.54c.343-.343.353-.928 0-1.271a.907.907 0 00-1.281 0L8 6.727 1.542.27C1.2-.085.604-.095.262.269a.914.914 0 000 1.271L6.718 8 .26 14.467c-.343.343-.353.929 0 1.272a.926.926 0 001.281 0L8 9.28l6.458 6.459c.343.343.938.353 1.28 0z","fill":"#888","fill-rule":"nonzero"}})])
          )
        }
      }
    